import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePOST, securePUT, withQuery } from '../utilities/FetchHelper';

class HotelInfoService {

    getOnboardingStatus(data) {
        const url = withQuery(URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_ONBOARDING_STATUS, {
            hotelCode: data.hotelCode
        })
        return fetchJSON(url, secureGET()).then(response => {
            return response.hotelOnboardingDetailsList ? response.hotelOnboardingDetailsList[0] : undefined
        }).catch((error) => {
            throw error
        })
    }

    putOnboardingStatus(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_ONBOARDING_STATUS_PUT
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        const formData = data.formData
        let putData = {
            ...formData
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    searchOnboardingApplicationsByStatus(status, offset, limit) {
        const url = withQuery(URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_ONBOARDING_STATUS, {
            status: status,
            limit: limit,
            offset: offset
        })
        return fetchJSON(url, secureGET()).then(response => {
            return response.hotelOnboardingDetailsList ? response : undefined
        }).catch((error) => {
            throw error
        })
    }

    getHotelInfo(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_INFO
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putHotelInfo(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_INFO
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        const putData = data.formData

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    postHotelInfo(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_INFO_POST
        return fetchJSON(url, { ...securePOST(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getBasicHotelInfo(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_BASIC_HOTEL_INFO
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getBasicHotelInfoWithBrandAndName(data) {
        const url = withQuery(URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_BASIC_HOTELS_INFO_WITH_BRAND_AND_NAME, {
            status: data.status,
            offset: data.offset,
            limit : data.limit
        })

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new HotelInfoService();